export default __webpack_public_path__ + "assets/images/minus-icon-ccf8df59.svg";